module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "order",
    style: (_vm.bannerFlag ? 'margin-top: 56px;' : '')
  }, [_c('div', {
    staticClass: "order-list w",
    staticStyle: {
      "min-height": "calc(100vh - 125px)"
    }
  }, [_c('div', {
    staticClass: "search-box"
  }, [_c('div', {
    staticClass: "search-box-left"
  }, [_c('div', {
    staticClass: "search-item"
  }, [_c('el-input', {
    attrs: {
      "size": "mini",
      "placeholder": "服务单号",
      "prefix-icon": "el-icon-search",
      "clearable": ""
    },
    on: {
      "clear": _vm.querySearch
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.querySearch.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.queryParams.servOrderNo),
      callback: function($$v) {
        _vm.$set(_vm.queryParams, "servOrderNo", $$v)
      },
      expression: "queryParams.servOrderNo"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "search-item"
  }, [_c('el-input', {
    attrs: {
      "size": "mini",
      "placeholder": "患者名称",
      "prefix-icon": "el-icon-search",
      "clearable": ""
    },
    on: {
      "clear": _vm.querySearch
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.querySearch.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.queryParams.demPatient),
      callback: function($$v) {
        _vm.$set(_vm.queryParams, "demPatient", $$v)
      },
      expression: "queryParams.demPatient"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "search-item"
  }, [_c('el-cascader', {
    attrs: {
      "options": _vm.common.category,
      "props": _vm.optionProps,
      "clearable": "",
      "show-all-levels": false,
      "size": "mini",
      "placeholder": "服务单类型"
    },
    on: {
      "change": _vm.changeServCataId
    },
    model: {
      value: (_vm.queryParams.servCataId),
      callback: function($$v) {
        _vm.$set(_vm.queryParams, "servCataId", $$v)
      },
      expression: "queryParams.servCataId"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "search-item"
  }, [_c('el-select', {
    attrs: {
      "size": "mini",
      "placeholder": "服务单状态"
    },
    model: {
      value: (_vm.queryParams.orderStatus),
      callback: function($$v) {
        _vm.$set(_vm.queryParams, "orderStatus", $$v)
      },
      expression: "queryParams.orderStatus"
    }
  }, _vm._l((_vm.common.dict.get('biz_order_status')), function(item) {
    return _c('el-option', {
      key: item.value,
      staticClass: "option-item",
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search-item"
  }, [_c('el-switch', {
    attrs: {
      "active-color": "#00a5d5",
      "inactive-color": "#909399",
      "active-value": "1",
      "inactive-value": "0",
      "active-text": "加急"
    },
    on: {
      "change": _vm.changeOrderRushFlag
    },
    model: {
      value: (_vm.queryParams.orderRushFlag),
      callback: function($$v) {
        _vm.$set(_vm.queryParams, "orderRushFlag", $$v)
      },
      expression: "queryParams.orderRushFlag"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "search-box-right"
  }, [_c('y-button', {
    attrs: {
      "text": "搜索",
      "classStyle": "main-btn"
    },
    on: {
      "btnClick": _vm.querySearch
    }
  }), _vm._v(" "), _c('y-button', {
    attrs: {
      "text": "重置",
      "classStyle": "main-btn ml"
    },
    on: {
      "btnClick": _vm.resetSearch
    }
  })], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "height": "calc(100vh - 258px)"
    },
    attrs: {
      "element-loading-text": "加载中...",
      "element-loading-background": "rgba(0, 0, 0, 0)"
    }
  }, [_c('div', {
    staticClass: "table-wrap",
    staticStyle: {
      "height": "calc(100vh - 238px)"
    }
  }, [(_vm.orderList.length > 0) ? _c('el-table', {
    ref: "multipleTable",
    staticStyle: {
      "width": "100%",
      "font-size": "13px"
    },
    attrs: {
      "data": _vm.orderList,
      "tooltip-effect": "dark",
      "size": "small",
      "stripe": true,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "序号",
      "width": "58",
      "show-overflow-tooltip": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s((_vm.queryParams.pageNum - 1) * _vm.queryParams.pageSize + scope.$index + 1))])]
      }
    }], null, false, 830294093)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "left",
      "label": "服务单号",
      "width": "210",
      "show-overflow-tooltip": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "code-wrap"
        }, [_vm._v("\n                " + _vm._s(scope.row.servOrderNo) + "\n                "), (scope.row.orderRushFlag === '1') ? _c('img', {
          attrs: {
            "src": "/static/images/rush.png"
          }
        }) : _vm._e()])]
      }
    }], null, false, 84749479)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "demPatient",
      "label": "患者名称",
      "width": "80",
      "align": "center",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "服务单类型",
      "align": "center",
      "width": "150",
      "show-overflow-tooltip": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('serv-tag', {
          attrs: {
            "code": scope.row.servCataId
          }
        })]
      }
    }], null, false, 3852078241)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "金额",
      "width": "90",
      "align": "center",
      "show-overflow-tooltip": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n              " + _vm._s(_vm.parseMoney(scope.row.orderAmount)) + "\n            ")]
      }
    }], null, false, 835403739)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "startTime",
      "label": "接单时间",
      "width": "143",
      "align": "center",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    key: _vm.desKey + 1,
    attrs: {
      "label": "设计计时",
      "width": "120",
      "align": "center",
      "show-overflow-tooltip": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(_vm.designTime(scope.row, '已锁定')) ? _c('span', {
          staticStyle: {
            "color": "darkorange"
          }
        }, [_vm._v("\n                已锁定\n              ")]) : (_vm.designTime(scope.row, '设计完成')) ? _c('span', {
          staticClass: "txtColor2"
        }, [_vm._v("\n               设计完成\n              ")]) : (_vm.designTime(scope.row, '/')) ? _c('span', [_vm._v("\n                /\n              ")]) : (_vm.designTime(scope.row, '已超时')) ? _c('span', {
          staticClass: "txtColor3"
        }, [_vm._v("\n               已超时\n              ")]) : _c('span', [_vm._v("\n               " + _vm._s(_vm.timeFormat(scope.row.desTime)) + "\n              ")])]
      }
    }], null, false, 1298104837)
  }), _vm._v(" "), _c('el-table-column', {
    key: _vm.confirmKey,
    attrs: {
      "label": "待确认计时",
      "width": "120",
      "align": "center",
      "show-overflow-tooltip": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(_vm.confirmTime(scope.row, '已锁定')) ? _c('span', {
          staticStyle: {
            "color": "darkorange"
          }
        }, [_vm._v("\n                已锁定\n              ")]) : (_vm.confirmTime(scope.row, '确认完成')) ? _c('span', {
          staticClass: "txtColor2"
        }, [_vm._v("\n                确认完成\n              ")]) : (_vm.confirmTime(scope.row, '/')) ? _c('span', [_vm._v("\n                /\n              ")]) : (_vm.confirmTime(scope.row, '已超时')) ? _c('span', {
          staticClass: "txtColor3"
        }, [_vm._v("\n                已超时\n              ")]) : (scope.row.orderStatus != '20') ? _c('span', [_vm._v("\n                " + _vm._s(_vm.timeFormat(scope.row.confirmTime)) + "\n              ")]) : _c('span', {
          staticStyle: {
            "color": "#ccc"
          }
        }, [_vm._v("未激活")])]
      }
    }], null, false, 4151623929)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "状态",
      "align": "center",
      "width": "147"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('dict-tag', {
          staticStyle: {
            "display": "inline",
            "cursor": "default"
          },
          attrs: {
            "dict": "biz_order_status",
            "value": scope.row.orderStatus
          }
        })]
      }
    }], null, false, 2145952667)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('s-button', {
          attrs: {
            "text": "详情"
          },
          on: {
            "btnClick": function($event) {
              return _vm.clickDetail(scope.row)
            }
          }
        }), _vm._v(" "), (scope.row.orderStatus == '91' || scope.row.orderStatus == '92') ? _c('s-button', {
          attrs: {
            "text": "删除"
          },
          on: {
            "btnClick": function($event) {
              return _vm.removeOrder(scope.row)
            }
          }
        }) : _vm._e()]
      }
    }], null, false, 4249795356)
  })], 1) : _vm._e(), _vm._v(" "), (_vm.noData) ? _c('div', {
    staticClass: "no-data"
  }, [_vm._v("\n          暂无数据\n        ")]) : _vm._e()], 1), _vm._v(" "), (_vm.orderList.length) ? _c('div', {
    staticClass: "pagination-wrap"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.queryParams.pageNum,
      "page-size": _vm.queryParams.pageSize,
      "layout": "total,prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.queryParams, "pageNum", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.queryParams, "pageNum", $event)
      }
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('el-dialog', {
    key: _vm.orderDetail.servOrderId,
    staticClass: "dialog-wrap",
    attrs: {
      "modal": false,
      "fullscreen": true,
      "modal-append-to-body": false,
      "visible": _vm.dialogVisible,
      "show-close": false
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "dialog-wrap-header",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('div', {
    staticClass: "dialog-header"
  }, [_vm._v("\n          " + _vm._s(_vm.orderDetail.servName)), _c('label', [_vm._v(" - ")]), _vm._v(_vm._s(_vm.orderDetail.servOrderNo)), _c('label', [_vm._v(" - ")]), _vm._v(_vm._s(_vm.orderDetail.demPatient) + "\n          "), (_vm.orderDetail.orderRushFlag === '1') ? _c('img', {
    attrs: {
      "src": "/static/images/rush.png"
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "dialog-button"
  }, [(_vm.orderDetail.orderStatus == '20' || _vm.orderDetail.orderStatus == '30' || _vm.orderDetail.orderStatus == '40') ? _c('y-button', {
    attrs: {
      "text": "投诉",
      "classStyle": "main-btn"
    },
    on: {
      "btnClick": function($event) {
        _vm.complaintFormVisible = true
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('y-button', {
    attrs: {
      "text": "返回",
      "classStyle": "main-btn"
    },
    on: {
      "btnClick": _vm.clickCloseDetail
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "dialog-wrap-content"
  }, [_c('el-tabs', {
    attrs: {
      "type": "card"
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "name": "info"
    }
  }, [_c('span', {
    staticClass: "tabs-pane-title",
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "el-icon-data-analysis"
  }), _vm._v(" "), _c('span', [_vm._v("服务单详情")])]), _vm._v(" "), _c('div', {
    staticClass: "tabs-pane-content"
  }, [(!['4010110', '3010130', '4010120'].includes(_vm.orderDetail.servCataId)) ? _c('detail-order', {
    attrs: {
      "orderDetail": _vm.orderDetail
    }
  }) : _vm._e(), _vm._v(" "), (['3010130'].includes(_vm.orderDetail.servCataId)) ? _c('orth-order', {
    attrs: {
      "orderDetail": _vm.orderDetail
    }
  }) : _vm._e(), _vm._v(" "), (['4010110', '4010120'].includes(_vm.orderDetail.servCataId)) ? _c('active-order', {
    attrs: {
      "orderDetail": _vm.orderDetail
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "name": "data"
    }
  }, [_c('span', {
    staticClass: "tabs-pane-title",
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "el-icon-film"
  }), _vm._v(" "), _c('span', [_vm._v("数据下载")])]), _vm._v(" "), _c('div', {
    staticClass: "tabs-pane-content"
  }, [_c('detail-down', {
    attrs: {
      "orderDetail": _vm.orderDetail
    }
  })], 1)]), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "name": "design"
    }
  }, [_c('span', {
    staticClass: "tabs-pane-title",
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "el-icon-finished"
  }), _vm._v(" "), _c('span', [_vm._v("设计信息")])]), _vm._v(" "), _c('div', {
    staticClass: "tabs-pane-content"
  }, [_c('detail-upload', {
    attrs: {
      "orderDetail": _vm.orderDetail,
      "report": _vm.orderDetail.designReport,
      "guide": _vm.orderDetail.designGuide
    },
    on: {
      "update:orderDetail": _vm.handleOrderDetailUpdate
    }
  })], 1)]), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "name": "activity"
    }
  }, [_c('span', {
    staticClass: "tabs-pane-title",
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "el-icon-timer"
  }), _vm._v(" "), _c('span', [_vm._v("进度详情")])]), _vm._v(" "), _c('div', {
    staticClass: "tabs-pane-content"
  }, [_c('detail-activity', {
    attrs: {
      "orderDetail": _vm.orderDetail
    }
  })], 1)])], 1)], 1)])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.complaintFormVisible,
      "width": "30%",
      "margin-top": "20vh",
      "append-to-body": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.complaintFormVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "pay-wrap-header",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('span', [_vm._v("申请投诉发单方")])]), _vm._v(" "), _c('el-form', {
    ref: "ruleForm",
    attrs: {
      "label-position": "left",
      "model": _vm.ruleForm
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "content",
      "label": "投诉理由:",
      "label-width": "120px",
      "rules": {
        required: true,
        message: '投诉理由不能为空',
        trigger: 'blur'
      }
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 4,
        maxRows: 8
      },
      "placeholder": "请详细说明投诉的原因"
    },
    model: {
      value: (_vm.ruleForm.content),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "content", $$v)
      },
      expression: "ruleForm.content"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "图片说明:",
      "label-width": "120px"
    }
  }, [_c('el-upload', {
    attrs: {
      "list-type": "picture-card",
      "action": "",
      "http-request": _vm.uploadFile,
      "data": {
        objectType: '18',
        objectTag: _vm.orderDetail.servOrderId
      },
      "auto-upload": true,
      "limit": 3,
      "multiple": "",
      "show-file-list": true,
      "before-upload": _vm.beforeUpload
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  })])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.complaintFormVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submitForm('ruleForm', '3')
      }
    }
  }, [_vm._v("提 交")])], 1)], 1), _vm._v(" "), _c('Customer', {
    staticClass: "customerSer",
    attrs: {
      "friendUid": _vm.orderDetail.demUserId
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2360a7b9","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Order/orderDes.vue
// module id = 614
// module chunks = 0